module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"homeTitle":"Intersolia Denmark - Your Environmental Management Partner"}}')
  delete Component.options._Ctor
}
